import { query } from '@confluence/query-preloader-tools';
import { ContentTypesHeaderQuery } from '@confluence/content-types-utils';

export function preloadContentTypesHeader(contentId, useObjectHeader) {
	return query({
		query: ContentTypesHeaderQuery,
		variables: {
			contentId,
			useObjectHeader,
		},
	});
}
